import { FC } from 'react';

import { Box, Typography } from '@mui/material';
import { BaseInputLabel, FormControl, NumberInput } from 'portfolio3/ui-kit';
import { InputController } from 'portfolio3/ui-kit/types';

import * as styles from './styles';

interface IPassingBallControlProps {
  minValue?: number;
  maxValue?: number;
  maxPossibleValue: number;
  minController: InputController;
  maxController: InputController;
  disabled?: boolean;
}

const PassingBallControl: FC<IPassingBallControlProps> = ({
  minValue,
  maxValue,
  maxPossibleValue,
  minController,
  maxController,
  disabled,
}) => {
  const maxValueInput = maxValue ?? maxPossibleValue;
  return (
    <FormControl
      renderMode="fixed"
      disabled={disabled}
      title={disabled ? 'Сначала выберите предмет или специальность' : ''}
      label={<BaseInputLabel>Проходной балл</BaseInputLabel>}
      control={
        <Box sx={styles.inputsContainer}>
          <FormControl
            renderMode="fixed"
            disabled={disabled}
            label={null}
            control={
              <NumberInput
                controller={minController}
                renderMode="fixed"
                size="medium"
                placeholder="0"
                min={0}
                max={maxValueInput ? maxValueInput : 1000}
                value={minValue}
                withControls={false}
                sx={styles.input}
              />
            }
          />
          <Typography variant="Paragraph MD/Regular">–</Typography>
          <FormControl
            renderMode="fixed"
            disabled={disabled}
            label={null}
            control={
              <NumberInput
                controller={maxController}
                renderMode="fixed"
                size="medium"
                min={0}
                max={maxPossibleValue && maxPossibleValue > 0 ? maxPossibleValue : 1000}
                placeholder={String(maxPossibleValue)}
                value={maxValue}
                withControls={false}
                sx={styles.input}
              />
            }
          />
        </Box>
      }
    />
  );
};

export default PassingBallControl;
